<template>
	<FileManager
		ref="fileManager"
		:service="fileService"
		:prefix="id"
		accept=".pdf"
		v-bind="{
			selected,
			submitted,
		}"
		v-slot="{
			browse,
			canMerge,
			deleted,
			empty,
			loading,
			merge,
			merging,
			prefix,
			refresh,
			renamed,
			results,
			listSubmitResult,
            listSubmitHisttoryResult,
			uploading,
			uploadPercent,
			zip,
			zipping,
			myAllResult,
			
		}"
		@loaded="filesLoaded"
		@merged="mergedDocuments"
		@zipped="zippedDocuments"
		@error="fileError($event)"
	>
		<b-row class="d-flex align-items-center">
			<!-- <b-col cols="4" lg="6" xl="4" class="mb-3 mt-4 text-left">
				<b-button-group> -->
					<!-- <b-button
						variant="secondary"
						@click="toggleList"
						:disabled="loading || uploading"
						class="px-2 px-lg-4 mr-2 ml-3"
						style="padding-right:2px;"
						v-if="previewing"
					>
						<span v-if="showList"><|</span>
						<span v-else>|></span>
					</b-button> -->

					<!-- <b-button
						variant="light"
						@click="browse"
						:disabled="loading || uploading"
						title="Upload"
						class="px-2 px-lg-4 btn btn-outline-primary"
					>
						<font-awesome-icon icon="cloud-upload-alt" fixed-width class="mr-2" />
					</b-button> -->

					<!-- <b-button v-if="showRefresh" variant="light" @click="refresh" :disabled="loading" title="Refresh">
						<font-awesome-icon icon="refresh" fixed-width :spin="loading" />
						<span class="sr-only">Refresh</span>
					</b-button>
				</b-button-group>
			</b-col> -->
			<!-- <b-col cols="8" lg="6" xl="8" class="mb-3 mt-4 text-right">
				<transition name="fade" mode="out-in">
					<div v-if="selected.length > 0" class="mr-3">
						<b-button
							variant="info"
							@click="merge(selected)"
							:disabled="merging || !canMerge"
							title="Create a combined PDF file from multiple source files"
							v-if="selected.length > 1"
						>
							<font-awesome-icon icon="file-pdf" fixed-width />
							Merge PDFs
						</b-button>

						<b-button
							variant="info"
							@click="zip(selected)"
							:disabled="zipping"
							title="Create a .zip archive of selected files"
						>
							<font-awesome-icon icon="file-zipper" fixed-width />
							Zip Files
						</b-button>
					</div>
				</transition>
			</b-col> -->
		</b-row>
		<b-row v-if="previewing" class="d-flex">
			<b-col cols="12" class="my-2">
			<div class="horizontal-scroll-container">
				<b-form-checkbox-group v-model="selected" name="selected">
				<b-list-group :flush="flush" class="horizontal-scroll-list">
					<transition-group name="fade" mode="out-in" tag="div" class="d-flex flex-row">
					<div v-for="result in listSubmitHisttoryResult" :key="result.path || result.filename" class="d-flex flex-row">
						<FileManagerItem
						v-if="result.path" 
						:prefix="prefix"
						:service="fileService"
						:value="result"
						v-slot="{
							canDelete,
							canDownload,
							canPreview,
							canRename,
							deleting,
							destroy,
							download,
							extension,
							fileName,
							isDirectory,
							lastModified,
							lastModifiedTimeAgo,
							mimeType,
							name,
							previewUrl,
							rename,
							renaming,
							size,
							displayName,
						}"
						@deleted="deleted"
						@error="fileError($event)"
						@renamed="renamed"
						>
						<b-list-group-item :disabled="deleting" :active="previewUrl == previewingUrl">
							<b-row>
							<b-col cols="12" class="d-flex align-items-center">
								<!-- <b-form-checkbox :value="fileName" class="mr-2" /> -->
								<div v-if="deleting">Deleting...</div>
								<div v-else-if="!isDirectory" class="d-flex align-items-center">
								<a
									href="#"
									v-if="canPreview"
									@click.prevent="previewFile(fileName, previewUrl)"
									class="font-weight-bold"
									:class="{ 'text-dark': previewUrl == previewingUrl, 'text-dark': previewUrl !== previewingUrl }"
								>
									{{ name.substring(0, 12) }}
								</a>
								</div>
							</b-col>
							</b-row>
						</b-list-group-item>
						</FileManagerItem>
						
						<FileManagerSubmitPacket
						v-else-if="result.filename"
						:prefix="prefix"
						:service="fileService"
						:value="result"
						v-slot="{
							canDelete,
							canDownload,
							canPreview,
							canRename,
							deleting,
							destroy,
							download,
							extension,
							fileName,
							isDirectory,
							lastModified,
							lastModifiedTimeAgo,
							mimeType,
							name,
							previewUrl,
							rename,
							renaming,
							size,
							displayName,
						}"
						@deleted="deleted"
						@error="fileError($event)"
						@renamed="renamed"
						>
						<b-list-group-item :disabled="deleting" :active="previewUrl === previewingUrl" :style="{ backgroundColor: '#FFF'}">
							<b-row>
							<b-col cols="12" class="d-flex align-items-center">
								<!-- <b-form-checkbox :value="fileName + '~PacketSubmit'" class="mr-2" /> -->
								<div v-if="deleting">Deleting...</div>
								<div v-else-if="!isDirectory" class="d-flex align-items-center">
								<a
									href="#"
									v-if="canPreview"
									@click.prevent="previewFile(fileName, previewUrl)"
									class="font-weight-bold"
									:class="{ 'text-dark': previewUrl === previewingUrl, 'text-dark': previewUrl !== previewingUrl }"
								>
									{{ displayName }}
								</a>
								</div>
							</b-col>
							</b-row>
						</b-list-group-item>
						</FileManagerSubmitPacket>
					</div>
					</transition-group>
				</b-list-group>
				</b-form-checkbox-group>
			</div>
			</b-col>
		</b-row>
		<div>
			<loading-indicator v-if="loading && empty" class="my-5" />
			<div v-else-if="listSubmitHisttoryResult.length>0">
				<b-row no-gutters>
					<b-col v-if="showList" cols="12" :lg="previewing ? 6 : 6" :xl="previewing ? 4 : 8">
						<b-form-checkbox-group v-model="selected" name="selected">
							<b-list-group :flush="flush">
							
								<!-- <h5 style="font-size: 1rem; text-align: left; margin:5px;font-weight:bold" v-if="!previewing">{{ listSubmitHisttoryResult?.length>0 ? "History" : "" }}</h5> -->
								<transition-group name="fade" mode="out-in">
									<FileManagerSubmitPacket
										v-for="result in listSubmitHisttoryResult"
										:key="result.filename"
										:prefix="prefix"
										:service="fileService"
										:value="result"
										v-slot="{
											canDelete,
											canDownload,
											canPreview,
											canRename,
											deleting,
											destroy,
											download,
											extension,
											fileName,
											isDirectory,
											lastModified,
											lastModifiedTimeAgo,
											mimeType,
											name,
											previewUrl,
											rename,
											renaming,
											size,
											displayName,
										}"
										@deleted="deleted"
										@error="fileError($event)"
										@renamed="renamed"
									>
										<b-list-group-item :disabled="deleting" :active="previewUrl == previewingUrl" class="appeal-document-list-custom-history" v-if="!previewing">
											<b-row>
												<b-col cols="9" md="8" xl="9" class="text-left">
													<b-row>
														<b-col
															cols="12"
															:md="previewing ? 12 : 7"
															:lg="previewing ? 12 : 7"
														>
															<b-row>
																
																<b-col
																	:cols="previewing ? 10 : 10"
																	:lg="previewing ? 12 : 11"
																>
																	<div v-if="deleting">Deleting...</div>
																	<div
																		v-else-if="!isDirectory"
																		class="d-flex align-items-top"
																	>
																		<div></div>
																		<div>
																			<div>
																				<a
																					href="#"
																					v-if="canPreview"
																					@click.prevent="
																						previewFile(
																							fileName,
																							previewUrl
																						)
																					"
																					class="font-weight-bold"
																					:class="
																						previewUrl == previewingUrl
																							? 'text-white'
																							: 'text-dark'
																					"
																				>
																					{{ displayName }}
																				</a>
																				<span v-else>{{ name }}</span>
																			</div>
																			<div class="small text-muted">
																				<span v-if="extension">{{
																					extension
																				}}</span>
																				<span v-if="extension && size"
																					></span
																				>
																				<span v-if="size">{{ size }}</span>
																			</div>
																		</div>
																	</div>
																	<div
																		v-else-if="isDirectory"
																		class="d-flex align-items-top"
																	>
																		<div>
																			<font-awesome-icon
																				icon="folder"
																				fixed-width
																				class="mr-4 text-muted"
																			/>
																		</div>
																		<div>
																			<div>
																				<a href="#">
																					{{ name }}
																				</a>
																			</div>
																		</div>
																	</div>
																</b-col>
															</b-row>
														</b-col>
														<b-col
															cols="12"
															:md="previewing ? 12 : 5"
															:lg="previewing ? 12 : 5"
														>
															<small class="d-none d-md-inline text-muted">
																<span>{{ formatDate(lastModified)
																					}}</span>
																&middot;
																<span>{{ lastModifiedTimeAgo }}</span>
															</small>
														</b-col>
													</b-row>
												</b-col>
												<b-col cols="3" md="4" xl="3" class="text-right">
													<b-button-group>
														<b-dropdown right variant="light">
															<template #button-content>
																<font-awesome-icon icon="cog" fixed-width />
															</template>
															<b-dropdown-item
																@click="download"
																:disabled="deleting || canDownload"
																>Download</b-dropdown-item
															>
															<b-dropdown-item
																:href="previewUrl"
																target="_blank"
																:disabled="deleting || !canPreview"
															>
																Preview
															</b-dropdown-item>
															<b-dropdown-item
																@click="rename"
																:disabled="renaming || !canRename"
															>
																Rename
															</b-dropdown-item>
															<b-dropdown-divider />
															<!-- <b-dropdown-item
																variant="danger"
																@click="destroy"
																:disabled="deleting || !canDelete"
															>
																<font-awesome-icon icon="trash" />
																<span>Delete</span>
															</b-dropdown-item> -->
														</b-dropdown>
													</b-button-group>
												</b-col>
											</b-row>
										</b-list-group-item>
									</FileManagerSubmitPacket>
								</transition-group>
							</b-list-group>
						</b-form-checkbox-group>
					</b-col>
					<b-col
						v-if="previewing"
						:cols="showList ? 12 : 12"
						:lg="showList ? 12 : 12"
						:xl="showList ? 12 : 12"
						class="text-right"
					>
						<PdfFrame :url="previewingUrl" />
					</b-col>
				</b-row>
			</div>
			<empty-result v-else >
				No documents found
				<!-- <template #content> Drag and drop files to attach to this level. </template> -->
			</empty-result>
		</div>
	</FileManager>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import FileManager from "@/clients/components/Layout/file-manager.vue";
import FileManagerItem from "@/clients/components/Layout/file-manager-item.vue";
import FileManagerSubmitPacket from "@/clients/components/Layout/file-manager-submit-packet.vue";
import PdfFrame from "@/shared/components/PdfFrame.vue";

import * as AppealFileService from "@/clients/services/appealFiles";

export default {
	name: "AppealFilesSubmitHistory",
	components: {
		FileManager,
		FileManagerItem,
		FileManagerSubmitPacket,
		PdfFrame,
	},
	props: {
		id: {
			required: true,
			type: [Number, String],
			default: "",
		},
		flush: {
			type: Boolean,
			default: true,
		},
		showRefresh: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			fileService: AppealFileService,
			selected: [],
			previewing: false,
			previewingUrl: "",
			showList: true,
			submitted: '',
		};
	},
	computed: mapGetters({}),
	created() {},
	mounted() {},
	methods: {
		formatDate(date) {
			// Split the date by "/"
			const [day, month, year] = date.split('/');
			// Return in MM/DD/YYYY format
			return `${month}/${day}/${year}`;
		},
		refresh() {
			this.$refs.fileManager.refresh();
		},
		updateComponent(data) {
			this.refresh();
		},
		filesLoaded(list) {
			// Cancel previewing if going to display empty
			if (!list || list.length === 0) {
				this.previewing = false;
			}
			
		},
		async previewFile(fileName, previewUrl) {
			if (previewUrl === this.previewingUrl) {
				this.previewing = false;
				this.previewingUrl = "";
			} else {
				this.previewing = true;
				this.previewingUrl = previewUrl;
			}
		},
		mergedDocuments(data) {
			const fileCount = data.data.length || 0;
			this.selected = [];

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Documents Merged",
				message: `${fileCount} file(s) merged into ${data.name}`,
			});
		},
		zippedDocuments(data) {
			const fileCount = data.data.length || 0;
			this.selected = [];

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Documents Zipped",
				message: `${fileCount} file(s) zipped into ${data.name}`,
			});
		},
		fileError(event) {
			this.$store.dispatch("apiError", {
				error: event,
				title: "File Error",
				message: event.message || "Unable to complete file operation and no message was provided.",
			});
		},
		toggleList() {
			this.showList = !this.showList;
		},
	},
	destroyed() {},
	watch: {
		previewing(val) {
			if (!val) {
				this.previewingUrl = "";
			}
		},
		selected: {
			handler(val) {
				this.$emit("update:selected", val);
			},
		},
	},
};
</script>
<style>
.horizontal-scroll-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent wrapping of content */
}

.horizontal-scroll-list {
  display: inline-block; /* Make the list items display inline */
  white-space: nowrap; /* Prevent list items from wrapping */
}

.horizontal-scroll-list .list-group-item {
  display: inline-block; /* Make each item display inline */
}
</style>